import { render } from "./AddVertical.vue?vue&type=template&id=1ab73618"
import script from "./AddVertical.vue?vue&type=script&lang=js"
export * from "./AddVertical.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__